import './Card.css'

interface IProps {
    img: string,
    name: string,
    description: string,
    type: 'dark' | 'light',
    buttonText: string
}

export const Card = (props: IProps) => {
    return (
        <div className='card'>
            <img src={props.img} alt=""/>
            <div className={`card__bottom-section card__bottom-section--${props.type}`}>
                <h1>{props.name}</h1>
                <p>{props.description}</p>
                <button className='card__bottom-section__button'>{props.buttonText}</button>
            </div>
        </div>
    )
}